/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	
	
	// ユーザーエージェント確認
	__webpack_require__(2);
	// cssの transform: をjsで書き換える
	// var transform_css = require('./caracol2/effect/transform_css.js');
	
	// var $window = $(window);
	
	
	
	/********************************
	* DOM読み込み完了
	*/
	$( function(){
	    'use strict';
	
	    // ヘッダと、ページトップに戻るボタンのアクション
	    var CaracolScrollAmount = __webpack_require__(3);
	    new CaracolScrollAmount( '.js-scroll-amount' );
	
	    // プログレス
	    __webpack_require__(4);
	
	    // ページスクロール
	    var CaracolPageScroll = __webpack_require__(8);
	    new CaracolPageScroll( 'a.js-pagescroll', {time:800, plus:0} );
	
	    // 画像の遅延読み込み
	    $('img.js-lazy').lazyload({effect:'fadeIn'});
	
	    // ソーシャルボタン
	    __webpack_require__(9).set_share_button( '.js-share-button' );
	
	    // ポップアップ設定
	    __webpack_require__(10);
	
	    // メニュー動作
	    __webpack_require__( 11 );
	    // require( './module/submenu.js' );
	
	    // スライダー
	    __webpack_require__(12);
	
	    // 各ページ用
	    __webpack_require__(13);
	    // require('./page/page_news.js');
	    // require('./page/page_story.js');
	
	    // キャラ用はなかチラつくので module/progress.js で遅延読み込み
	    // require('./page/page_chara.js');
	
	
	});
	


/***/ },
/* 2 */
/***/ function(module, exports) {

	/*****************************
	* ブラウザ情報を取得する
	*/
	
	exports.isMobile = (function(){ 'use strict'; return isMobile; })();
	exports.browser = (function(){ 'use strict'; return browser; })();
	
	
	var isMobile = checkMobile();
	var browser = getBrowser();
	
	/****************************
	* モバイル判定
	*/
	function checkMobile(){
	    'use strict';
	    var agent = navigator.userAgent;
	
	    if(agent.search(/iPhone/) != -1 || agent.search(/iPad/) != -1 || agent.search(/iPod/) != -1 || agent.search(/Android/) != -1){
	        $('body').addClass('isMobile');
	        $.isMobile = true;
	        return true;
	    }else{
	        $('body').addClass('isPC');
	        $.isMobile = false;
	        return false;
	    }
	}
	
	/****************************
	* ブラウザ判別
	*/
	function getBrowser(){
	    'use strict';
	
	    var ua = window.navigator.userAgent.toLowerCase();
	    var ver = window.navigator.appVersion.toLowerCase();
	    var name = 'unknown';
	
	    if (ua.indexOf("msie") != -1){
	        if (ver.indexOf("msie 6.") != -1){
	            name = 'ie6';
	        }else if (ver.indexOf("msie 7.") != -1){
	            name = 'ie7';
	        }else if (ver.indexOf("msie 8.") != -1){
	            name = 'ie8';
	        }else if (ver.indexOf("msie 9.") != -1){
	            name = 'ie9';
	        }else if (ver.indexOf("msie 10.") != -1){
	            name = 'ie10';
	        }else{
	            name = 'ie';
	        }
	    }else if(ua.indexOf('trident/7') != -1){
	        name = 'ie11';
	    }else if (ua.indexOf('chrome') != -1){
	        name = 'chrome';
	    }else if (ua.indexOf('safari') != -1){
	        name = 'safari';
	    }else if (ua.indexOf('opera') != -1){
	        name = 'opera';
	    }else if (ua.indexOf('firefox') != -1){
	        name = 'firefox';
	    }
	    return name;
	}
	
	


/***/ },
/* 3 */
/***/ function(module, exports) {

	/*****************************
	上下スクロールで対象にクラスを付与するクラス
	ver 1.0.0
	
	メニューや、トップに戻るボタンの出し入れに使う。
	
	# usage
	var scroll_amount = new CaracolScrollAmount( target, {config} );
	
	## target
	検知対象となる element
	
	## config
	パラメーター。値は初期値。
	
	{
		up: 80,  // 上へのスクロールに反応するスクロール積算値。
		down: 80,  // 下へのスクロールに反応するスクロール積算値。
		offset_top: 50, // スクロール位置がこの値より上ならページ最上部と判断
		offset_bottom: 50, // スクロール位置がこの値より下ならページ最下部と判断
	
		// 状態によって付与されるクラス
		class:{
			pinned: 'ccl-amount_pinned',
			unpinned: 'ccl-amount_unpinned',
			top: 'ccl-amount_top',
			nottop: 'ccl-amount_not-top',
			bottom: 'ccl-amount_bottom',
			notbottom: 'ccl-amount_not-bottom',
			initial: 'ccl-amount'
		},
	
		// イベント
		onPin: function(){},
		onUnPin: function(){},
		onTop: function(){},
		onNotTop: function(){},
		onBottom: function(){},
		onNotBottom: function(){}
	}
	
	------------------------
	ver1.0.0 2016/11/22
	- とりあえず作った。
	
	*/
	var CaracolScrollAmount;
	
	module.exports = CaracolScrollAmount = function( target, config ){
		'use strict';
	
		var defaults = {
			up: 80,
			down: 80,
			offset_top: 70,
			offset_bottom: 70,
	
			// 状態によって付与されるクラス
			class:{
				pinned: 'ccl-amount_pinned',
				unpinned: 'ccl-amount_unpinned',
				top: 'ccl-amount_top',
				nottop: 'ccl-amount_not-top',
				bottom: 'ccl-amount_bottom',
				notbottom: 'ccl-amount_not-bottom',
				initial: 'ccl-amount'
			},
			// イベント
			onPin: function(){},
			onUnPin: function(){},
			onTop: function(){},
			onNotTop: function(){},
			onBottom: function(){},
			onNotBottom: function(){}
		};
	
		this.opt = $.extend( defaults, config );
		this.target = target;
		this.$target = $(target);
		this.$window =$(window);
		this.win_height = null;	// ブラウザウィンドウの高さ
		// this.doc_height = null;	// ドキュメントの高さ
		this.last_scroll = 0; // 1回前の座標
		this.count_scroll = 0; // スクロール量の積算
	
		this.is_started = false; // 開始した
		this.is_top = false; // 一番上にスクロールした
		this.is_bottom = false; // 一番下にスクロールした
		this.is_pinned = false; // ピンを立てた
	
		// 開始
		this.start();
	};
	
	/********************
	* スクロール検知処理を開始
	*/
	CaracolScrollAmount.prototype.start = function(){
		'use strict';
	
		// すでに開始していたら無視
		if( this.is_started ) return;
	
		// 基礎クラスを付与
		this.$target.addClass( this.opt.class.initial );
	
		// リサイズイベントでドキュメント高さチェック
		this.resize();
		this.$window.on('resize', $.throttle( 100, $.proxy( this.resize, this )));
	
		// スクロールイベント
		this.scroll();
		this.is_started = true;
		this.$window.on('scroll', $.throttle( 100, $.proxy( this.scroll, this )));
	
		// 一応1秒間毎にチェックも入れる
		setInterval( $.proxy( this.scroll, this ), 1000 );
	};
	
	/********************
	* スクロール検知処理を停止
	*/
	CaracolScrollAmount.prototype.stop = function(){
		'use strict';
		this.$window.off( 'scroll', _.throttle( $.proxy( this.scroll, this ), 50 ) );
	};
	/********************
	* スクロール処理
	*/
	CaracolScrollAmount.prototype.scroll = function(){
		'use strict';
	
		var opt = this.opt;
		var scroll = this.$window.scrollTop();
		var distance = scroll - this.last_scroll; // 移動量
	
		// 位置イベントのチェック
		this.check_top_bottom( scroll );
	
		// スクロール量を積算。もし逆方向にスクロールしたらリセット
		if( this.count_scroll > 0 && distance > 0 ){
			this.count_scroll += distance;
		}else if( this.count_scroll < 0 && distance < 0 ){
			this.count_scroll += distance;
		}else{
			this.count_scroll = distance;
		}
	
		this.last_scroll = scroll;
	
		// スクロールが規定量越えたらピンを立てる
		if(  this.count_scroll >= opt.down && !this.is_pinned ){
			// 下にスクロール
			this.is_pinned = true;
			this.$target.addClass( opt.class.pinned );
			this.$target.removeClass( opt.class.unpinned );
	
		}else if( this.count_scroll <= -opt.up && this.is_pinned ){
			// 上にスクロ−ル
			this.is_pinned = false;
			this.$target.addClass( opt.class.unpinned );
			this.$target.removeClass( opt.class.pinned );
		}
	
	};
	
	/********************
	* 最上部か最下部かのチェック
	*/
	CaracolScrollAmount.prototype.check_top_bottom = function( scroll ){
		'use strict';
	
		var opt = this.opt;
		var $target = this.$target;
		var scroll_bottom = $(document).height() - this.win_height;
	
	
		if( !this.is_top && scroll <= opt.offset_top ){
			// ページ最上部
			this.is_top = true;
			$target.addClass( opt.class.top );
			$target.removeClass( opt.class.nottop );
			$target.addClass( opt.class.notbottom );
			opt.onTop();
	
		}else if( !this.is_bottom && scroll >= scroll_bottom - opt.offset_bottom){
			// ページ最下部
			this.is_bottom = true;
			$target.addClass( opt.class.bottom );
			$target.addClass( opt.class.nottop );
			$target.removeClass( opt.class.notbottom );
			opt.onBottom();
	
		}else if( this.is_top && scroll > opt.offset_top ){
			// 最上部から離れた
			this.is_top = false;
			$target.addClass( opt.class.nottop );
			$target.removeClass( opt.class.top );
			opt.onNotTop();
	
		}else if( this.is_bottom && scroll < scroll_bottom - opt.offset_bottom ){
			// 最下部から離れた
			this.is_bottom = false;
			$target.addClass( opt.class.notbottom );
			$target.removeClass( opt.class.bottom );
			opt.onNotBottom();
		}
	};
	
	
	/********************
	* ウィンドウをリサイズしたら高さなどをチェック
	*/
	CaracolScrollAmount.prototype.resize = function(){
		this.win_height = this.$window.height();
	}
	


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	
	
	// プログレス登録
	var CaracolLoadProgress = __webpack_require__(5);
	var progress = new CaracolLoadProgress({
	    // urls: window.app.progress_base_urls,
	    onProgress: onProgress, onComplete:onComplete, onError:onError
	});
	// 読み込んだ外部ファイルで指示されている先読み指定ファイルを取得
	// progress.add_urls( window.app.progress_page_urls );
	
	// プログレス開始
	progress.start();
	// start_inView();
	
	/**********************
	* エラー
	*/
	function onError( url, jqXHR, textStatus, errorThrown ){
	    console.log("[load error]", url);
	}
	
	/**********************
	* プログレス：読み込み中
	*/
	function onProgress( total, count, percent, url ){
	    var per = percent * 100;
	    $('.js-fadein-progress').css({ width:per+'%' });
	}
	/**********************
	* プログレス：読み込み完了
	*/
	function onComplete( total, count ){
	    setTimeout( function(){
	        $('.js-fadein-progress').css({ width:'100%' });
	        $('.c-fadein').addClass('c-fadein_start');
	    }, 500 );
	
	    // フェードイン終わったら消す
	    $('.c-fadein')
	    .on("oTransitionEnd mozTransitionEnd webkitTransitionEnd transitionend",
	        function( e ){
	            // 透明度以外のアニメ終了は無視
	            if( e.originalEvent.propertyName !== 'opacity' ) return;
	
	            $('.c-fadein').hide();
	
	            // スクロールインエフェクト
	            start_inView();
	        }
	    );
	}
	/**********************
	* inView 開始
	*/
	function start_inView(){
	    // トップページのビジュアル、アニメスタート
	    // $('#page-home .home-bg').attr('data-home-start', 'true');
	    // $('#page-home .home__center-sp').attr('data-home-start', 'true');
	console.log("iv");
	    var CaracolScrollInView = __webpack_require__(7);
	    var inView = new CaracolScrollInView( '.p-iv', {
	        class:{
	            in:'p-iv_in'
	        }
	    } );
	
	    // inViewはホームページだけ遅延させる
	    // var delay = $('#page-home').length ? 1300 : 0;
	
	    // setTimeout( function(){
	    //     // スマホヘッダの表示
	    //     $('#page-home .c-sp-header_home').attr('data-home-start', 'true');
	        inView.start();
	    // }, delay );
	
	}
	
	
	


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/*****************************
	画像や、ファイルの読み込みによるプログレスバー
	
	2016/12/05 ver 1.2.0	読み込み部分を別ライブラリに分けた
							onError() を用意した
	2016/05/27 ver 1.1.1	違うhostnameのものは弾くようにした
	2016/05/24 ver 1.1	onProgress() に urlを追加
							add_urls() を追加
	2016/05/20 ver 1.0	とりあえず作成
	*/
	
	/* [javascript] *********************************
	var $progress_bar = $('#fadein .fadein__progress');
	var CaracolLoadProgress = require('./caracol/util/jquery.load_progress.js');
	
	var progress = new CaracolLoadProgress({
	    onProgress: function( total, count, percent ){
	        $progress_bar.css({ width: (percent * 100)+'%' });
	    },
	    onComplete: function( total, count ){
	        $progress_bar.css({ width: '100%' });
	        setTimeout( function(){ $('#fadein').remove(); }, 1700);
	    }
	});
	progress.start();
	***********************************/
	
	/* [補足] *********************************
	progress.add_urls( array );
	
	自動的に <img src="〜"> <image src="〜"> を読み込み対象とするが、
	それ以外に読み込みに追加したいファイルを配列で指定。
	***********************************/
	
	
	
	var CaracolLoadProgress;
	
	module.exports = CaracolLoadProgress = function( config ){
		'use strict';
	
		var defaults = {
			onProgress: function( total, count, percent ){},
			onComplete: function( total, count ){},
			onError: function( url, jqXHR, textStatus, errorThrown ){},
			urls: []
		}
		this.opt = jQuery.extend( defaults, config );
		this.urls = this.opt.urls;
		this.total = 0;
	}
	/***************************
	* add url
	*/
	CaracolLoadProgress.prototype.add_urls = function( list ){
		this.urls = this.urls.concat( list );
	}
	/***************************
	* start
	*/
	CaracolLoadProgress.prototype.start = function(){
		'use strict';
	
		var self = this;
		// var count = 0;
		var finished = [];
	
		// 画像を数える
		this.checkImageTags();
	
		// 画像他をプリロード
		var preload = __webpack_require__(6);
		preload( this.urls, {
			onProgress: function( url, total, count, percent ){
				self.opt.onProgress( total, count, percent, url );
				finished.push( url );
	    	}
		})
		.fail( function( url, jqXHR, textStatus, errorThrown ){
			self.opt.onError( url, jqXHR, textStatus, errorThrown );
		})
		.done( function( total, count  ){
			// 全部読み終わった
			self.opt.onComplete( total, count );
		});
	
		// // 個々のURLを取得し、deferredオブジェクトを返す
		// var promise = this.urls.map( function( url ){
		// 	// console.log(url);
		// 	return jQuery.get( url )
		// 	.then( function( e ){
		// 		var percent = ( count +1 ) / self.total;
		// 		self.opt.onProgress( self.total, count, percent, url );
		// 		finished.push( url );
		// 		count ++;
		// 	});
		// });
	
		// // 全部読み込み終わったら実行
		// jQuery.when.apply( null, promise )
		// .done( function(){
		// 	self.opt.onComplete( self.total, count );
		// });
	
		// // 3秒後に読み込めなかったURLを表示
		// setTimeout( function(){
		// 	for( var i=0; i<self.urls.length; i++ ){
		// 		var url = self.urls[i];
		// 		// 終了リストに存在しない
		// 		if( $.inArray( url, finished ) < 0 ){
		// 			console.log("[load error]",url);
		// 		}
		// 	}
		// }, 3000 );
	
	}
	
	/***************************
	* check <img> tags
	*/
	CaracolLoadProgress.prototype.checkImageTags = function(){
		'use strict';
	
		var hostname = /^https?:\/\/[^\/]+\//.exec( window.location.href )[0];
		var imgs = document.getElementsByTagName('img');
		var images = document.getElementsByTagName('image');
		var length;
	
		// <img>
		length = imgs.length;
		if( length ){
			for( var i=0; i<length; i++ ){
				// 違うホストのものは弾く
				if( imgs[i].src.indexOf(hostname) === 0 ){
					this.urls.push( imgs[i].src );
				}
			}
		}
	
		// SVGの<image>
		length = images.length;
		if( length ){
			for( var i=0; i<length; i++ ){
				// 違うホストのものは弾く
				if( images[i].src.indexOf(hostname) === 0 ){
					this.urls.push( images[i].src );
				}
			}
		}
	
		this.total = this.urls.length;
	}
	


/***/ },
/* 6 */
/***/ function(module, exports) {

	/*****************************
	指定されたURLの配列を読み込んだら $.Deferred を返す
	***********************************/
	/*
	var urls = ['image1.jpg', 'image2.jpg', 'image3.jpg'];
	var preload = require('./caracol2/util/preload.js');
	
	preload( urls,{
	    onProgress: function( url, total, count, percent ){
	        console.log("{progress}", url, total, count, percent);
	    }
	})
	.fail( function( url, jqXHR, textStatus, errorThrown ){
	    console.log("{error}", url);
	}).done( function( total, count ){
	    console.log("{comp}", total, count);
	});
	*/
	
	module.exports = function( list, config ){
		'use strict';
	
		var defaults = {
			onProgress: function( url, total, count, percent ){}
		}
		var opt = jQuery.extend( defaults, config );
	
		// Deferred オブジェクト
	    var defer = $.Deferred();
		var count = 0;
		var total = list.length;
	
		// 個々のURLを取得し、deferredオブジェクトを返す
		var promise = list.map( function( url ){
			return jQuery.get( url )
			.fail( function( jqXHR, textStatus, errorThrown ){
				defer.rejectWith( this, [url, jqXHR, textStatus, errorThrown] );
			})
			.done( function( e ){
				var percent = ( count +1 ) / total;
				opt.onProgress( url, total, count, percent );
				count ++;
			});
		});
	
		// 全部読み込み終わったら実行
		jQuery.when.apply( null, promise )
		.done( function(){
			defer.resolve( total, count );
		});
	
		// promiseオブジェクトを返して fail()、done()、always()を使えるようにする
		return defer.promise();
	}


/***/ },
/* 7 */
/***/ function(module, exports) {

	/*****************************
	スクロールでエリアに入るとクラスを付与
	
	target : 検知対象となる class / id
	config : {
		class:{
			// 画面内に入ったら付与
			'in' : 'inView_in',
			// 画面の外に出たら付与
			'out' : 'inView_out'
		}
		// 画面に入った判定の距離。0にすると画面端で判定
		// 必ずin_rangeより小さい値にする
		in_range : 50,
		// 画面から出た判定の距離
		out_range: 0,
		//表示エリアの中だけピンをたてる。上にスクロールするとまた表示
		is_inView_only: false
	}
	
	
	*/
	var CaracolScrollInView;
	
	module.exports = CaracolScrollInView = function( target, config ){
		'use strict';
	
		var defaults = {
			class:{
				in : 'inView_in',
				out : 'inView_out'
			},
			in_range : 50,
			out_range: 40,  // 画面外判定。
			margin_bottom: 50,  // 最下部の許容値
			is_inView_only: false
	
		};
		this.opt = $.extend( defaults, config );
		this.target = target;
		this.$target = $(target);
		this.is_started = false;
		this.is_ended = false;  // 全部表示した
		this.$window =$(window);
		this.win_height = null;
		this.doc_height = null;
	
		this.ev_check_element = null;
	
		this.DATA_TOP = 'ccl-inView-top';
		this.DATA_BOTTOM = 'ccl-inView-bottom';
	
	};
	
	/********************
	* スクロール検知処理を開始
	*/
	CaracolScrollInView.prototype.start = function(){
		'use strict';
		// すでに開始していたら無視
		if( this.is_started ) return;
	
		// 各アイテムの高さをチェック
		this.check_element();
		this.ev_check_element = setInterval( $.proxy( this.check_element, this ), 2000 );
	
		// リサイズイベントでドキュメント高さチェック
		this.resize();
		var ev_resize = $.throttle( 100, $.proxy( this.resize, this ));
		this.$window.on( 'resize', ev_resize );
	
		// スクロールイベント
		this.scroll();
		var ev_scroll = $.throttle( 100, $.proxy( this.scroll, this));
		this.$window.on( 'scroll', ev_scroll );
	
		this.is_started = true;
	};
	
	/********************
	* 検知処理を終了
	*/
	CaracolScrollInView.prototype.stop = function(){
		clearInterval( this.ev_check_element )
		this.$window.off( 'resize', this.resize );
		this.$window.off( 'scroll', this.scroll );
	}
	
	/********************
	* 対象エレメントの座標と高さをチェック
	*/
	CaracolScrollInView.prototype.check_element = function(){
		var DATA_TOP = this.DATA_TOP;
		var DATA_BOTTOM = this.DATA_BOTTOM;
	
		this.$target.each( function(){
			var $elm = $(this);
			var top = $elm.offset().top;
			var bottom = top + $elm.height();
			$elm.data( DATA_TOP, top );
			$elm.data( DATA_BOTTOM, bottom );
		});
	}
	
	/********************
	* スクロール処理
	*/
	CaracolScrollInView.prototype.scroll = function(){
		'use strict';
	
		var self = this;
		var $window = this.$window;
		var $target = this.$target;
		var opt = this.opt;
	
		// スクロール上位置と下位置
		var scroll_top = $window.scrollTop();
		var scroll_bottom = scroll_top + this.win_height;
	
		// 対象エレメントを順にチェック
		$target.each( function(){
	
			// エレメントの上辺・下辺を取得
			var $elm = $(this);
			var top = $elm.data( self.DATA_TOP );
			var bottom = $elm.data( self.DATA_BOTTOM );
	
	
			// エリア内限定の設定ではなく、
			// すでに完了クラスが付与されていたら無視
			if( !opt.is_inView_only && $elm.hasClass(opt.class.in) ) return true;
	
			if( !opt.is_inView_only ){
				// 画面内判定：表示エリアより上は全部ピン立てる
				if( scroll_bottom - opt.in_range > top  ){
					$elm.addClass( opt.class.in );
				}
			}else{
				// 表示エリア内だけ
				if( self.is_inView( top, bottom, scroll_top, scroll_bottom )){
					$elm.removeClass( opt.class.out );
					$elm.addClass( opt.class.in );
				}else if( $elm.hasClass( opt.class.in ) && self.is_outView( top, bottom, scroll_top, scroll_bottom ) ){
					$elm.removeClass( opt.class.out );
					$elm.addClass( opt.class.out );
				}
			}
		});
	
		// エリア内限定でないなら、一番下までスクロールしたら停止
		if( !opt.is_inView_only ){
			if( scroll_bottom >= this.doc_height - opt.margin_bottom ){
				self.stop();
			}
		}
	};
	
	/********************
	* エリア内にエレメントが見えているか
	* element top / element bttom / scroll top / scroll bottom
	*/
	CaracolScrollInView.prototype.is_inView = function( et, eb, st, sb ){
		'use strict';
		var ir = this.opt.in_range;
		// 上辺が画面内 || 下辺が画面内
		if( st + ir < et && et < sb - ir || st + ir < eb && eb < sb - ir ) return true;
		return false;
	}
	
	/********************
	* エリア外に移動したか
	* element top / element bttom / scroll top / scroll bottom
	*/
	CaracolScrollInView.prototype.is_outView = function( et, eb, st, sb ){
		'use strict';
		var or = this.opt.out_range;
		// 下辺が画面外 || 上辺が画面外
		if( eb < st + or || sb - or < et ) return true;
		return false;
	}
	
	
	/********************
	* ウィンドウをリサイズしたら高さなどをチェック
	*/
	CaracolScrollInView.prototype.resize = function(){
		this.win_height = this.$window.height();
		this.doc_height = $(document).height();
	}
	


/***/ },
/* 8 */
/***/ function(module, exports) {

	/*****************************************
	
	jQuery.syg_pagescroll
	version 1.3
	Hiroshi Fukuda <dada@sygnas.jp>
	http://sygnas.jp/
	
	The MIT License
	
	Copyright (c) 2011-2012 Hiroshi Fukuda, http://sygnas.jp/
	
	/*****************************************
	
	
	/*****************************************
	= example 1 =
	
		<a href="#hogehoge">hogehoge</a>
	
		<div id="hogehoge">
		</div>
	
		<script src="lib/jquery.syg_pagescroll.1.0.js"></script>
		<script>
			new $.SygPageScroll( 'a' );
		</script>
	
	
	= example 2 =
	
		<a href="#hogehoge" class="scroll">hogehoge</a>
	
		<div id="hogehoge">
		</div>
	
		<script src="lib/jquery.easing.1.3.js"></script>
		<script src="lib/jquery.syg_pagescroll.1.0.js"></script>
		<script>
			new $.SygPageScroll( 'a.scroll', {time:2000, easing:'easeInOutCubic'} );
		</script>
	
	*****************************************/
	
	/*****************************************
	
	2016.11.23 ver.2.1
		・$(target).click(); を $(document).on('click',target,function(){}); に変更
	2016.06.8 ver 2
		・Webpack用に作り直し
	2015.04.26 ver 1.3
		・スクロール先IDが無い場合は普通にリンクさせる
	2013.03.08 ver 1.1
		・位置補正オプション「plus」を追加。
	
	*****************************************/
	
	var CaracolPageScroll;
	
	module.exports = CaracolPageScroll = function( target, config ){
		'use strict';
	
		var defaults = {
			easing:			'swing',
			time:			1000,
			plus:			0
		};
	
		this.opt = $.extend( defaults, config );
	
		var self = this;
		var opt = this.opt;
	
		/*****************************
		* click setting
		*/
		$(document).on('click',target,
			$.proxy(
				function( e ){
					var hash = e.currentTarget.hash;
	
					if( $(hash).get(0) ){
						var y = $(hash).offset().top +opt.plus;
						$('html,body').animate( {scrollTop:y}, self.opt.time, self.opt.easing );
						return false;
					}else{
						return true;
					}
	
				}
			)
		);
	
	};
	


/***/ },
/* 9 */
/***/ function(module, exports) {

	/*
	各種ソーシャルサービスボタンを簡単設置
	
	2016/11/24 ver.2.0.0
		- Webpack対応
	*/
	
	
	exports.set_share_button = function( target ){
		'use strict';
	
		var window_opt = "width=550, height=450,personalbar=0,toolbar=0,scrollbars=1,resizable=1";
		var e = encodeURIComponent;
	
		// クリック動作
		$(document).on('click', target, function(){
			var $this = $(this);
			var url = $this.data('ccl-share-url');
			var msg = $this.data('ccl-share-msg');
			var via = $this.data('ccl-share-via');
			var flw = $this.data('ccl-share-flw');
	
			if( !url ) url = location.href;
			if( !msg ) msg = document.title;
	
			switch( $this.data('ccl-share-svc') ){
				case 'twitter':
					twitter(url, msg, via, flw); break;
				case 'facebook':
					facebook(url); break;
				case 'line':
					line(url, msg); break;
				case 'feedly':
					feedly(url); break;
				case 'pocket':
					pocket(url); break;
				case 'hatebu':
					hatebu(url, msg); break;
				case 'google':
					google(url); break;
			}
	
			return false;
		});
	
		/***************************
		* Twitter
		*/
		function twitter( url, msg, via, follow ){
		    'use strict';
			var openURL = 'http://twitter.com/share?url=' + e(url) + '&text=' + e(msg) + '+';
			if( via ) openURL += '&via=' + e(via);
			if( follow ) openURL += '&related=' + e(follow);
			window.open( openURL, 'tweetwindow', window_opt );
			return false;
		}
	
		/***************************
		* Facebook
		*/
		function facebook( url ){
		    'use strict';
			var openURL = 'http://www.facebook.com/share.php?u='+ e(url);
			window.open( openURL, 'facebookwindow', window_opt );
			return false;
		}
	
		/***************************
		* LINE
		*/
		function line( url, msg ){
		    'use strict';
			window.location.href = 'line://msg/text/' + e(msg) + ' ' + e(url);
			return false;
		}
	
		/***************************
		* feedly
		*/
		function feedly( url ){
		    'use strict';
			var openURL = 'http://feedly.com/i/subscription/feed/' + e(url);
			window.open( openURL, 'feedlywindow', window_opt );
			return false;
		}
	
		/***************************
		* Pocket
		*/
		function pocket( url ){
		    'use strict';
			var openURL = 'http://getpocket.com/edit?url=' + e(url);
			window.open( openURL, 'feedlywindow', window_opt );
			return false;
		}
	
		/***************************
		* はてなブックマーク
		*/
		function hatebu( url, msg ){
		    'use strict';
			var openURL = '//b.hatena.ne.jp/add?mode=confirm&url=' + e(url) + "&title=" + e(msg);
			window.open( openURL, 'hatebuwindow', window_opt );
			return false;
		}
	
		/***************************
		* google plus
		*/
		function google( url ){
		    'use strict';
			var openURL = 'https://plus.google.com/share?url=' + e(url);
			window.open( openURL, 'googlewindow', window_opt );
			return false;
		}
	
	};

/***/ },
/* 10 */
/***/ function(module, exports) {

	
	// 画像ポップアップ
	 $('a.js-magnific').magnificPopup({
	    type: 'image'
	 });
	
	// youtube用ポップアップ
	$('a.js-youtube').magnificPopup({
	    disableOn: 700,
	    mainClass: 'mfp-fade',
	    removalDelay: 160,
	    preloader: false,
	    fixedContentPos: false,
	    type: 'iframe',
	    iframe: {
	        patterns: {
	            youtube: {
	                index: 'youtube.com',
	                id: 'v=',
	                src: '//www.youtube.com/embed/%id%?rel=0&autoplay=1'
	            }
	        }
	    }
	});
	


/***/ },
/* 11 */
/***/ function(module, exports) {

	// var $window = $(window);
	
	// スマホ用：メニューをタップするとメニューを消す
	if( $.isMobile ){
	    $('.c-mainmenu a').click(function(event){
	        console.log("click");
	        // event.preventDefault();
	        $('.js-header-pop-target').attr('data-sp-menu', 'close');
	        $('.js-header-pop-open').attr('data-sp-menu', 'close');
	    });
	}
	
	// メニューon/off
	$('.js-header-pop-open').click(function(){
	    var $target = $('.js-header-pop-target');
	    var status = $target.attr('data-sp-menu');
	    var $body = $('body');
	
	    $target.attr('data-sp-menu', status!=='open' ? 'open' : 'close');
	    $(this).attr('data-sp-menu', status!=='open' ? 'open' : 'close');
	
	    // // 現在のスクロール座標を記録・復元
	    // if( $target.attr('data-sp-menu') === 'open' ){
	    // 	var scroll = $('body').scrollTop();
	    // 	$body.attr('data-scroll', scroll)
	    //     // $body
		   //  .attr('data-sp-menu', 'open')
	    // 	.css({top: -scroll});
	
	
	    // }else{
		   //  $body.attr('data-sp-menu', 'close')
	    // 	.scrollTop( $body.attr('data-scroll') )
	    // 	.css({top: 0});
	    // }
	
	    return false;
	});
	
	// $('.js-menu-open-target a').click(function(event) {
	//     var $target = $('.js-menu-open-target');
	//     $target.removeClass('header__content_open');
	//     $target.addClass('header__content_close');
	// });
	
	// トップページのメニュー位置調整
	// if( $('#page-home').length && !$('body').hasClass('isMobile') ){
	//     var $header = $('.visual .header');
	//     var $visual = $('.visual');
	
	//     function set_mainmenu_position(){
	//         var visual_bottom = $visual.offset().top +  $visual.height();
	//         var win_bottom = $window.scrollTop() + $window.height();
	
	//         if( visual_bottom > win_bottom ){
	//             $header.css({position:'fixed'});
	//         }else{
	//             $header.css({position:'absolute'});
	//         }
	//     }
	//     $.throttle( 100, set_mainmenu_position );
	//     set_mainmenu_position();
	// }
	


/***/ },
/* 12 */
/***/ function(module, exports) {

	// コメント用スライダー
	if( $.isMobile ){
	    $('.js-comment-slider').bxSlider({
	        auto: false,
	        infiniteLoop: true,
	        prevSelector: '#js-bx_prev',
	        nextSelector: '#js-bx_next',
	        prevText: '<i class="icon-syg-arrowmini-left5"></i>',
	        nextText: '<i class="icon-syg-arrowmini-right5"></i>',
	        //                        paer: false
	        //                        pagerCustom: '.characters__select'
	    });
	}


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	
	var $window = $(window);
	
	page_home();
	
	function page_home(){
		'use strict';
		// #page-home 以外は抜ける
		if( !$('#page-home').length ) return;
	
		resize_visual();
	}
	
	// ビジュアルのリサイズ
	function resize_visual(){
	    var $visual_pc_parent = $('.visual');
	    var visual_pc = $('.visual__pc').get(0);
	
	    function onResize(){
	        var per = $visual_pc_parent.width() / 1200;
	
	        // リサイズは transformのほうが早い
	        var style = visual_pc.style;
	        __webpack_require__(14).
	            set_transform( style, 'scale('+per+')' );
	    }
	
	    // スマホの場合はリサイズ動作しない
	    if( !$.isMobile ){
	    	$window.on( 'resize', $.throttle(100, onResize) );
	        setTimeout( onResize, 500);
	    }
	
	}
	


/***/ },
/* 14 */
/***/ function(module, exports) {

	// ------------------------------------------------------------
	// スタイルの transform を設定する関数
	// http://hakuhin.jp/js/css_transform.html
	// ------------------------------------------------------------
	/*
	var set_transform = require('./caracol/effect/set_transform.js');
	var style = $('.target').get(0).style;
	set_transform.caracolSetTransform( style, 'scale(.8)' );
	*/
	
	
	exports.set_transform = function( style, value ){
		var list = [
			"transform",
			"webkitTransform",
			"MozTransform",
			"msTransform",
			"OTransform"
		];
		var i;
		var num = list.length;
		for(i=0;i < num;i++){
			if(style[list[i]] !== undefined){
				style[list[i]] = value;
				return true;
			}
		}
		return false;
	}

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** bundle.js
 **/